import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import AgencyBudgetPage from './components/AgencyBudgetPage';

const AgencyBudgetPageFunction = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Agency Budget Control and Report</h3>
      </Col>
    </Row>
    <Row>
      <AgencyBudgetPage />
    </Row>
  </Container>
);

export default AgencyBudgetPageFunction;
